import { personalGallery } from "../data/portfolioData";

function ChapterBeyondBrief() {
  return (
    <section id="beyond-the-brief" className="chapter beyond-brief-section" data-section="beyond" data-testid="beyond-brief-section">
      <div className="chapter-intro">
        <div className="section-kicker"><span>04.B</span><span>BEYOND THE BRIEF / PERSONAL DISCIPLINES</span></div>
        <div><h2 data-testid="beyond-brief-heading">Craft is how you do everything.</h2><p className="chapter-lead">The systems mindset travels. Outside the boardroom, focus, rhythm, and a respect for small variables keep the work honest.</p></div>
      </div>
      <div className="beyond-grid">
        {personalGallery.map((item) => (
          <article className="beyond-card" key={item.id} data-testid={`beyond-brief-card-${item.id}`}>
            <figure className="beyond-image"><img src={item.image} alt={item.alt} data-testid={`beyond-brief-image-${item.id}`} /><span>{item.kicker}</span><figcaption>{item.caption}</figcaption></figure>
            <div className="beyond-card-body"><h3>{item.title}</h3><p>{item.body}</p><div className="beyond-telemetry">{item.telemetry.map((line, index) => <div key={line.label} data-testid={`beyond-brief-telemetry-${item.id}-${index}`}><span>{line.label}</span><strong>{line.value}</strong></div>)}</div></div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default ChapterBeyondBrief;
